@if (navigationBreadcrumb) {
<qa-navigation-breadcrumbs
  [navigationBreadcrumb]="navigationBreadcrumb"
></qa-navigation-breadcrumbs>
} @if (matTabConfig) {
<qa-tab-list [matTabsConfig]="matTabConfig"></qa-tab-list>
} @if (config) {
<qa-grid-data [config]="config"></qa-grid-data>
}
